import Layout from '@components/layout/side-nav/layout/layout';
import { useSession } from '@lib/auth/session';
import { Navigate, Outlet } from 'react-router-dom';
import type { Socket } from 'socket.io-client';

interface ProtectedRouteProps {
  socket: Socket;
}

const ProtectedRoute = ({ socket }: ProtectedRouteProps): JSX.Element => {
  const loggedIn = useSession();

  return loggedIn ? (
    <Layout socket={socket}>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
